export const FETCH_EPG_VERSION_INIT = 'FETCH_EPG_VERSION_INIT';
export const FETCH_EPG_VERSION_SUCCESS = 'FETCH_EPG_VERSION_SUCCESS';
export const FETCH_EPG_VERSION_ERROR = 'FETCH_EPG_VERSION_ERROR';